import { Button, Modal, Form } from "react-bootstrap";
import { useState, useEffect } from "react";

function FirmaElectronica({ documento, documentoId, solicitudId }) {
  const [fileBase64, setFileBase64] = useState(null); // Almacena el archivo en Base64
  const [algorithm, setAlgorithm] = useState("SHA256withRSA"); // Algoritmo por defecto
  const [format, setFormat] = useState("PAdES"); // Formato de firma por defecto
  const [showModal, setShowModal] = useState(false); // Estado para controlar el modal
  const [isSigned, setIsSigned] = useState(false); // Estado para controlar el modal
  const [signedData, setSignedData] = useState(""); // Almacenar el documento firmado
  const [nombreDocumento, setNombreDocumento] = useState(""); // Nombre del documento
  const [descripcionSolicitud, setDescripcionSolicitud] = useState(""); // Descripción de la solicitud
  const userId = localStorage.getItem("id");
  const userRol = localStorage.getItem("rol");

  useEffect(() => {
    if (window.AutoScript) {
      window.AutoScript.cargarAppAfirma(); // Abre la aplicación AutoFirma
    } else {
      console.error("AutoScript no se ha cargado correctamente.");
    }
  }, []);

  // Convierte un archivo en Base64
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNombreDocumento(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result.split(",")[1];
        setFileBase64(base64Data);
      };
      reader.readAsDataURL(file);
    }
  };

  // Función para firmar un documento
  const signDocument = (documentToSign) => {
    if (!documentToSign) {
      alert("No hay documento para firmar.");
      return;
    }

    const extraParams = [
      "signaturePage=1",
      "signaturePositionOnPageLowerLeftX=100",
      "signaturePositionOnPageLowerLeftY=100",
      "signaturePositionOnPageUpperRightX=400",
      "signaturePositionOnPageUpperRightY=200",
      "layer2Text=Firmado por $$SUBJECTCN$$ el día $$SIGNDATE=dd/MM/yyyy$$ con certificado emitido por $$ISSUERCN$$",
      "layer2FontFamily=Arial",
      "layer2FontSize=12",
      "layer2FontColor=000000",
      "layer2FontStyle=0",
    ].join("&");

    try {
      window.AutoScript.sign(
        documentToSign,
        algorithm,
        format,
        extraParams,
        async (signedData) => {
          setSignedData(signedData);
          //alert("El documento ha sido firmado correctamente.");
          setShowModal(true); // Mostrar el modal
        },
        (type, message) => {
          console.error("Error al firmar:", message);
          alert("Error al firmar: " + message);
        }
      );
    } catch (e) {
      console.error("Error al invocar AutoScript para firmar:", e);
    }
  };

  // Crea un documento (solo para usuario)
  const sendDocument = async () => {
    const now = new Date();
    const fechaHora = now.toISOString().split("T").join(" ").split("Z")[0];
    const documentData = {
      NombreDocumento: "signed_" + nombreDocumento,
      Documento: signedData,
      usuario_id: userId,
      FirmadoUser: true,
      FechaSubida: fechaHora
    };

    try {
      const response = await fetch("https://oficinavirtual-solponiente.com/api/documentos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", 'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(documentData),
      });

      if (response.ok) {
        const result = await response.json();
        sendSolicitud(result.DocumentoID); // Crea una solicitud asociada
      } else {
        alert("Error al guardar el documento.");
      }
    } catch (error) {
      alert("No se pudo conectar con la base de datos.");
    }
  };

  // Crea una solicitud asociada (solo para usuario)
  const sendSolicitud = async (docId) => {
    const now = new Date();
    const fechaHora = now.toISOString().split("T").join(" ").split("Z")[0];
    const solicitudData = {
      UsuarioID: userId,
      DocumentoID: docId,
      Estado: "pendiente",
      FirmadoUser: true,
      Descripcion: descripcionSolicitud,
      FechaSolicitud: fechaHora
    };

    try {
      const response = await fetch("https://oficinavirtual-solponiente.com/api/solicitudes", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", 'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(solicitudData),
      });

      if (response.ok) {
        alert("Solicitud creada correctamente.");
        setIsSigned(true)
        setShowModal(false)
      } else {
        alert("Error al guardar la solicitud.");
      }
    } catch (error) {
      alert("No se pudo conectar con la base de datos.");
    }
  };

  // Actualiza el estado de la solicitud (solo para admin)
  const updateSolicitud = async () => {
    try {
      const response = await fetch(`https://oficinavirtual-solponiente.com/api/solicitudes/${solicitudId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ FirmadoAdmin: true, Documentos: signedData, NombreDocumento: "signedbyadmin.pdf" }),
      });

      if (response.ok) {
        alert("La solicitud ha sido actualizada y el documento firmado.");
        setIsSigned(true)
      } else {
        alert("Error al actualizar la solicitud.");
      }
    } catch (error) {
      alert("No se pudo conectar con la base de datos.");
    }
    setShowModal(false)
  };

  return (
    <div>
      {userRol === "usuario" && (
        <>
          <Form.Group controlId="archivo">
            <Form.Label>Añadir archivo</Form.Label>
            <Form.Control type="file" accept=".pdf" onChange={handleFileUpload} />
          </Form.Group>
          <Form.Group controlId="descripcionSolicitud" className="mt-4">
            <Form.Label>Descripción de la solicitud</Form.Label>
            <Form.Control
              type="textarea"
              rows={6}
              placeholder="Escribe la descripción aquí..."
              value={descripcionSolicitud}
              onChange={(e) => setDescripcionSolicitud(e.target.value)}
            />
          </Form.Group>
        </>
      )}

      <div className="mt-4 mb-2">
        <Button
          variant="primary"
          onClick={() => {
            const documentToSign = userRol === "admin" ? documento : fileBase64;
            signDocument(documentToSign);
          }}
        >
          Firmar Y Enviar
        </Button>

        {/* {userRol === "usuario" && (
          <Button variant="success" className="ms-2" onClick={sendDocument}>
            Enviar
          </Button>
        )} */}

        {/* {userRol === "admin" && signedData && (
          <Button variant="success" className="ms-2" onClick={updateSolicitud}>
            Actualizar Solicitud
          </Button>
        )} */}
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Firma completada</Modal.Title>
        </Modal.Header>
        <Modal.Body>El documento se ha firmado correctamente.</Modal.Body>
        <Modal.Footer>

          {userRol === "admin" && signedData && (
            <Button variant="success" className="ms-2" onClick={updateSolicitud}>
              Actualizar Solicitud
            </Button>
          )}
          {userRol === "usuario" && (
            <Button variant="success" className="ms-2" onClick={sendDocument}>
              Enviar
            </Button>
          )}
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default FirmaElectronica;
